import { useContext, useEffect } from "react";
import { useFormik } from "formik";
import crudApi from "@serie3/common/api/crudApi";
import SettingsContext from "@serie3/common/auth/SettingsContext";
import SettingsConfig from "@serie3/freelancesplaceapi/Config/Settings/SettingsConfig";
import SettingsForm from "@serie3/freelancesplaceapi/Form/Settings/SettingsForm";
import SaveButton from "../../../layout/Buttons/SaveButton";

const LOCALES = [
  { value: "de-DE", label: "German (Germany)" },
  { value: "de-AT", label: "German (Austria)" },
  { value: "de-CH", label: "German (Switzerland)" },
  { value: "en-US", label: "English (US)" },
  { value: "en-GB", label: "English (UK)" },
  { value: "fr-FR", label: "French (France)" },
  { value: "es-ES", label: "Spanish (Spain)" },
  { value: "it-IT", label: "Italian (Italy)" },
  { value: "nl-NL", label: "Dutch (Netherlands)" },
  { value: "pl-PL", label: "Polish (Poland)" },
];

const UserSettings = () => {
  const { settings, setSettings } = useContext(SettingsContext);

  const form = SettingsForm.createSettingsForm(setSettings);
  const formik = useFormik(form);

  useEffect(() => {
    const load = async () => {
      const response = await crudApi.getAll(SettingsConfig.endpoints.get);
      if (response.status === 200 && response.data.Settings?.length > 0) {
        formik.setValues(SettingsForm.setEditData(response.data.Settings[0]));
      }
    };
    load();
  }, []);

  return (
    <div style={{ maxWidth: "480px", padding: "24px" }}>
      <div style={{ marginBottom: "24px" }}>
        <h5 style={{ fontWeight: 700, fontSize: "1rem", color: "#212121", marginBottom: "4px" }}>
          Language & Region
        </h5>
        <p style={{ fontSize: "0.85rem", color: "#757575", margin: 0 }}>
          Choose your preferred locale for number and currency formatting.
        </p>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", fontSize: "0.82rem", fontWeight: 600, color: "#424242", marginBottom: "6px" }}>
          Locale
        </label>
        <select
          name="locale"
          value={formik.values.locale}
          onChange={formik.handleChange}
          style={{
            width: "100%", padding: "9px 12px", borderRadius: "8px",
            border: "1px solid #e0e0e0", fontSize: "0.9rem",
            background: "#fff", color: "#212121", outline: "none",
            appearance: "none", cursor: "pointer",
          }}
        >
          <option value="">— Select locale —</option>
          {LOCALES.map((l) => (
            <option key={l.value} value={l.value}>{l.label}</option>
          ))}
        </select>
        {formik.values.locale && (
          <div style={{ marginTop: "8px", fontSize: "0.8rem", color: "#757575" }}>
            Preview: {(1234567.89).toLocaleString(formik.values.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
          </div>
        )}
      </div>

      <SaveButton handleClick={(e) => { e.preventDefault(); formik.handleSubmit(); }} />
    </div>
  );
};

export default UserSettings;
